import styled from '../../theme/styled-with-theme';
import { BlockContainer, BlockContainerProps } from '../Layout';
import { mediaQueries } from '../../styles/media-queries';
import { SpacingToken } from '../../theme/tokens/spacing';
import { UnstyledButton } from '../Button';

interface Props extends BlockContainerProps {
  backgroundImage?: string;
}

export const Modal = styled('div')`
  display: flex;
  position: fixed;
  inset: 0;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 0;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.7);
`;

export const BlockContainerBgImage = styled(BlockContainer)<Props>`
  background-image: ${({ backgroundImage }) => `url(${backgroundImage})`};
  background-size: cover;
  background-position: 50% 50%;
  position: relative;
  &:before {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-color: rgba(255, 255, 255, 0.5);
  }
`;

export const VideoButton = styled(UnstyledButton)`
  z-index: 1;
  outline: 0;

  .playIconBackground,
  .playIconCenter {
    transition: 0.2s fill ease;
  }

  &:hover .playIconBackground,
  &:focus .playIconBackground {
    fill: ${({ theme }) => theme.color.playIconCenter};
  }

  &:hover .playIconCenter,
  &:focus .playIconCenter {
    fill: ${({ theme }) => theme.color.playIconBackground};
  }
`;

export const PlayIcon = styled('svg')`
  cursor: pointer;
  max-width: 100%;
  width: 100%;
  height: 100%;
  z-index: 0;
`;

export const CloseIconPositioner = styled('div')`
  cursor: pointer;
  text-align: right;
  position: absolute;
  top: 0;
  right: 0;
  padding: ${({ theme }) => theme.spacing.m};
`;

export const Iframe = styled('iframe')`
  border: 0;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
`;

const IFRAME_PADDING_X: SpacingToken = 'sm';
const IFRAME_PADDING_X_TABLET: SpacingToken = 'xl';
const IFRAME_MAX_HEIGHT = '80vh';

const VIDEO_ASPECT_RATIO = 0.5625;

export const IframeWrapper = styled('div')`
  position: relative;
  overflow: hidden;
  padding-top: ${VIDEO_ASPECT_RATIO * 100}%;
`;

export const IframePositioner = styled('div')`
  max-width: calc(
    ${IFRAME_MAX_HEIGHT} / ${VIDEO_ASPECT_RATIO} -
      (${({ theme }) => theme.spacing[IFRAME_PADDING_X]} * 2)
  );
  max-height: ${IFRAME_MAX_HEIGHT};
  position: absolute;
  width: calc(100% - (2 * ${({ theme }) => theme.spacing[IFRAME_PADDING_X]}));
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  ${mediaQueries.tablet} {
    max-width: calc(
      ${IFRAME_MAX_HEIGHT} / ${VIDEO_ASPECT_RATIO} -
        (${({ theme }) => theme.spacing[IFRAME_PADDING_X_TABLET]} * 2)
    );
    width: calc(
      100% - (2 * ${({ theme }) => theme.spacing[IFRAME_PADDING_X_TABLET]})
    );
  }
`;
